import { AutogenModelOrderCustomerStops, AutogenRowOrderCustomerStops } from "./autogen/AutogenModelOrderCustomerStops";

export class ModelOrderCustomerStops extends AutogenModelOrderCustomerStops<RowOrderCustomerStops> {
	constructor() {
		super(RowOrderCustomerStops);
	}
}

export class RowOrderCustomerStops extends AutogenRowOrderCustomerStops {
}